import { render, staticRenderFns } from "./FolderProperties.vue?vue&type=template&id=1e95581e&scoped=true&"
import script from "./FolderProperties.vue?vue&type=script&lang=ts&"
export * from "./FolderProperties.vue?vue&type=script&lang=ts&"
import style0 from "./FolderProperties.vue?vue&type=style&index=0&id=1e95581e&lang=scss&scoped=true&"
import style1 from "./FolderProperties.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e95581e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VAvatar,VBtn,VCard,VCheckbox,VChip,VCol,VCombobox,VContainer,VIcon,VImg,VListItem,VListItemContent,VListItemTitle,VRow,VSelect,VTab,VTabItem,VTabs,VTabsItems,VTextField,VTextarea,VTimeline,VTimelineItem})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src567975772/src/search.myaileron.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e95581e')) {
      api.createRecord('1e95581e', component.options)
    } else {
      api.reload('1e95581e', component.options)
    }
    module.hot.accept("./FolderProperties.vue?vue&type=template&id=1e95581e&scoped=true&", function () {
      api.rerender('1e95581e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FolderProperties.vue"
export default component.exports